import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { LocalizationContext } from '../../../hoc/Localization';
import TitleContent from '../../TinyComponents/TitleContent';
import MarkDown from '../../TinyComponents/MarkDown';
import InlineEditor from '../../InlineEditor';
import styles from './styles.less';
import { EditorContext } from '../../../hoc/Editor';
import Gallery from '../../Gallery';
import Skill from '../Skill';
import Perk from '../Perk';

const Info = ({ description, content, skills, perks, learn, course, canEdit, instructions }) => {
  const { editMode } = React.useContext(EditorContext);
  const { t } = React.useContext(LocalizationContext);

  return (
    <Row id="infoContainer" className={styles.row} type="flex" gutter={55}>
      {(!!description || !!editMode) && (
        <Col className={styles.col} sm={12}>
          <div>
            <TitleContent
              title={<h2>{t('course.details.content.about')}</h2>}
              content={
                <InlineEditor
                  type="wysiwyg"
                  label="description"
                  value={description}
                  hasTranslations
                  settings={{
                    placeholder: t('course.edit.description.placeholder'),
                  }}
                >
                  <MarkDown source={description} />
                </InlineEditor>
              }
            />
          </div>
        </Col>
      )}

      {(!!learn || !!editMode) && (
        <Col className={styles.col} sm={12}>
          <TitleContent
            title={<h2>{t('course.details.content.learn')}</h2>}
            content={
              <div>
                {!editMode && (
                  <>
                    <Skill skills={skills} />
                    <Perk perks={perks} />
                  </>
                )}
                <InlineEditor
                  type="wysiwyg"
                  label="learn"
                  value={learn}
                  hasTranslations
                  settings={{
                    placeholder: t('course.edit.learn.placeholder'),
                  }}
                >
                  <MarkDown source={learn} />
                </InlineEditor>
              </div>
            }
          />
        </Col>
      )}

      {(!!content || !!editMode) && (
        <Col className={styles.col} sm={12}>
          <TitleContent
            title={<h2>{t('course.details.content.content')}</h2>}
            content={
              <InlineEditor
                type="wysiwyg"
                label="content"
                value={content}
                hasTranslations
                settings={{
                  placeholder: t('course.edit.content.placeholder'),
                }}
              >
                <MarkDown source={content} />
              </InlineEditor>
            }
          />
        </Col>
      )}

      {editMode && (
        <Col className={styles.col} sm={12}>
          <TitleContent
            title={<h2>{t('course.details.content.instructions')}</h2>}
            content={
              <div>
                <InlineEditor
                  type="textarea"
                  label="instructions"
                  value={instructions}
                  hasTranslations
                  rows={6}
                  settings={{
                    placeholder: t('course.edit.instructions.placeholder'),
                  }}
                >
                  <MarkDown source={instructions} />
                </InlineEditor>
              </div>
            }
          />
        </Col>
      )}

      {(editMode || (course.images && course.images.length !== 0)) && (
        <Col className={styles.col} sm={12}>
          <TitleContent
            title={t('details.gallery')}
            content={<Gallery images={course.images} canEdit={canEdit} course={course} />}
          />
        </Col>
      )}
    </Row>
  );
};

Info.propTypes = {
  description: PropTypes.string,
  content: PropTypes.string,
  skills: PropTypes.array,
  learn: PropTypes.string,
  course: PropTypes.object,
  canEdit: PropTypes.bool,
  perks: PropTypes.array,
  instructions: PropTypes.string,
};

Info.defaultProps = {
  description: '',
  instructions: '',
  content: '',
  skills: [],
  learn: '',
  course: {},
  canEdit: false,
  perks: [],
};

export default Info;
